<template>
  <div class="poll-management-parent">
    <h1>All Polls</h1>
    <div class="poll-wrapper">
      <div class="single-poll" v-for="(poll, idx) in polls" :key="poll.pls_id">
        <div>Poll Id: {{ poll.pls_id }}</div>
        <div>Poll Title: {{ poll.pls_name }}</div>
        <div>Poll Points: {{ poll.pls_points }}</div>
        <button @click="managePoll(poll.pls_id)">
          {{ $t("adminAdd.managePoll") }}
        </button>
        <button @click="deletePoll(poll.pls_id)">
          {{ $t("adminAdd.deletePoll") }}
        </button>
        <button @click="editPoll(idx)">
          {{ $t("adminAdd.editPoll") }}
        </button>
      </div>
      <addNewPoll
        v-if="addNewPollBool"
        :isEditing="isEditing"
        :selectedPoll="selectedPoll"
        @close="closeAddNewPollModal"
      />
    </div>
    <button @click="addNewPollBool = true">
      {{ $t("adminAdd.addNewPoll") }}
    </button>
  </div>
</template>

<script>
import addNewPoll from "../admin-pages/AddNewPoll.vue";
import api from "@/api";
export default {
  components: {
    addNewPoll
  },
  data() {
    return {
      polls: [],
      addNewPollBool: false,
      isEditing: false,
      selectedPoll: null
    };
  },
  mounted() {
    this.init();
  },
  methods: {
    init() {
      this.getAllPolls();
      console.log(this);
    },
    async getAllPolls() {
      try {
        const res = await api.getAllPolls({ polltype: "reg" });
        this.polls = res.data.data;
        // console.log(this.polls)
      } catch (error) {
        this.handleError(error);
      }
    },
    async deletePoll(pls_id) {
      try {
        const res = await api.deletePoll({ params: { pls_id } });
        this.getAllPolls();
      } catch (error) {
        this.handleError(error);
      }
    },
    async managePoll(pls_id) {
      console.log(pls_id);
      this.$router.push(`editPolls/${pls_id}`);
    },
    closeAddNewPollModal() {
      this.addNewPollBool = false;
      this.isEditing = false;
      this.selectedPoll = null;
      this.getAllPolls();
    },
    editPoll(id) {
      this.selectedPoll = this.polls[id];
      this.addNewPollBool = true;
      this.isEditing = true;
    }
  }
};
</script>

<style scoped lang="scss">
.poll-management-parent {
  padding: 20px;
  .poll-wrapper {
    .single-poll {
      margin: 20px 0;
    }
  }
  .tag-wrapper {
    input {
      min-width: 300px;
      max-width: 30%;
      margin: 0 0 20px 0;
    }
    .single-tag {
      margin: 0 0 20px 0;
      border-bottom: 1px solid black;
      button {
        margin: 20px 0;
      }
    }
  }
}
</style>
